import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Divider } from "antd";
import { textFormatter } from "components/Common/formatter";
import TitleWithDivider from "components/Common/components/TitleWithDivider";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  informationContainer: {
    display: "flex",
    width: "100%",
    paddingRight: 25,
  },
  column: {
    width: "100%",
  },
  rowData: {
    display: "flex",
  },
  title: {
    fontSize: 13,
    fontWeight: 300,
    width: "60%",
  },
  data: {
    fontSize: 13,
    fontWeight: 600,
    width: "40%",
    whiteSpace: "break-spaces",
  },
  red: {
    color: "#ff4d4f",
  },
  columnTitle: {
    fontSize: "14px!important",
    fontWeight: "400!important",
  },
  form: {
    width: "100%",
  },
  comment: {
    color: "#777777",
    fontWeight: 400,
  },
});

const FeedbackFormTab = ({ feedbacks }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {!!feedbacks?.current?.length && (
        <div className={classes.informationContainer}>
          <div className={classes.column}>
            <TitleWithDivider title="Current answers" />
            <br />
            {feedbacks.current?.map(item => (
              <>
                <div className={classes.rowData} key={item?.question}>
                  <div className={classes.title}>{item?.question}</div>
                  <div className={classes.data}>
                    {textFormatter(item?.answer)}
                    {item?.comment && <div className={classes.comment}>{item?.comment}</div>}
                  </div>
                </div>
                <Divider />
              </>
            ))}
          </div>
        </div>
      )}

      {!!feedbacks?.prev?.length && (
        <div className={classes.informationContainer}>
          <div className={classes.column}>
            <TitleWithDivider title="Previous answers" />
            <br />
            {feedbacks.prev?.map(item => (
              <>
                <div className={classes.rowData} key={item?.question}>
                  <div className={classes.title}>{item?.question}</div>
                  <div className={classes.data}>
                    {textFormatter(item?.answer)}
                    {item?.comment && <div className={classes.comment}>{item?.comment}</div>}
                  </div>
                </div>
                <Divider />
              </>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FeedbackFormTab;
